import { replaceSourceNameForTenantIfRequired } from '@modules/common/utils';
import {
  EqlField,
  IntegrationChannelType,
  ObjectType,
} from 'generated/graphql';
import { capitalize, truncate } from 'lodash';

interface getFormattedDisplayNameForEqlFieldOptions {
  shouldRemoveFileUploadPrefix: boolean;
  eqlField: EqlField | null;
  maxPrefixCharLength?: number; // to be used for large names, like FileUpload
  isUnifiedFieldEnabled: boolean;
}

export const getFormattedDisplayNameForEqlField = ({
  shouldRemoveFileUploadPrefix,
  eqlField,
  maxPrefixCharLength,
  isUnifiedFieldEnabled,
}: getFormattedDisplayNameForEqlFieldOptions): string => {
  if (!eqlField) {
    return '';
  }

  if (eqlField.objectType && eqlField.objectType !== ObjectType.Feedback) {
    return `${capitalize(eqlField.objectType)} - ${eqlField.displayName}`;
  }

  const getSourceName = (sourceName: string) => {
    let modifiedDisplayName = sourceName;
    if (shouldRemoveFileUploadPrefix) {
      modifiedDisplayName = modifiedDisplayName.replaceAll(
        `${IntegrationChannelType.FileUpload}-`,
        '',
      );
    }

    if (isUnifiedFieldEnabled) {
      modifiedDisplayName = modifiedDisplayName.replaceAll(
        'Common',
        'Unified Fields',
      );
    }

    modifiedDisplayName =
      replaceSourceNameForTenantIfRequired(modifiedDisplayName);

    return modifiedDisplayName.trim();
  };

  if (eqlField.detail?.metadata?.source) {
    const sourceName = getSourceName(eqlField.detail?.metadata?.source);

    const prefix = maxPrefixCharLength
      ? truncate(sourceName, {
          length: maxPrefixCharLength,
        })
      : sourceName;

    return `${eqlField.displayName} (${prefix})`.trim();
  }

  return eqlField.displayName;
};
